module.exports = __webpack_public_path__ + "img/073.a5ca6352.jpg";